/**
 * Created by hp on 2017/8/1.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dialog, Mask, Button, ButtonArea} from 'react-weui'
import {WKOwnDialog} from './wk'
import axios from 'axios';
import qr from 'qr-encode'
import '../styles/SubscribeChannel.css';
import endClassTipsIcon from '../images/ended-class-tips3.png';

class SubscribeChannel extends Component {
    constructor() {
        super();
        this.handleSubscribeChannel = this.handleSubscribeChannel.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            Qrcode: null
        }
    }

    handleClose() {
        this.props.dispatch({type: 'SUBSCRIBE_CHANNEL_HIDE'});
    }

    handleSubscribeChannel() {
        const {channel} = this.props;
        axios.post(`/api/channel/${channel.id}/subscribe`).then((response) => {
            if (response.data.code === 0) {
                this.handleClose();
                this.context.page.showToast('预约成功');
                this.props.dispatch({type: 'CHANNEL_SUBSCRIBED_CHANNEL'});
            } else {
                this.handleClose();
                let text = () => {
                    return <span><i className="iconfont icon-cuowu wk-toast-error"/><span>{response.data.msg}</span></span>
                };
                this.context.page.showToast(text(), '', true, 2000);
            }
        });
    }

    componentDidMount() {
        if (!this.props.account.subscribed){
            axios.get(`/api/liveroom/${this.props.liveroomId}/get_qrcode`, {
                params: {
                    object_id: this.props.channelId,
                    object_type: 'channel'
                }
            })
                .then(res => {
                    if (res.data.code === 0) {
                        this.setState({
                            Qrcode: res.data.data.qrcode_content
                        })
                    }
                })
        }
    }

    render() {
        const {showSubscribeChannel, account, channel} = this.props;
        if (!showSubscribeChannel)
            return null; 

        if (!account.subscribed) {
            return (
                <WKOwnDialog show={true} type="ios"
                        title={'长按扫码预约专栏'}
                        buttons={[{
                            label: <span style={{color: '#666'}}>关闭</span>,
                            onClick: this.handleClose.bind(this)
                        }]}>
                    <p>专栏内课程可反复收听</p>
                    <p className="content__qrcode"><img src={qr(this.state.Qrcode)} alt="subscribe"/></p>
                    <p>预约后，可接收专栏<br/>内所有课程开课提醒</p>
                </WKOwnDialog>
            )
        }

        const buttons = [
            {
                label: '暂不',
                type: 'default',
                onClick: () => this.handleClose()
            },
            {
                label: '预约',
                onClick: () => this.handleSubscribeChannel()
            }
        ];

        return (
            <div className="subscribe-channel">
                <WKOwnDialog title="温馨提醒" buttons={buttons} show={true}>
                    <p>专栏内课程可反复收听，预约后，可接收专栏内所有课程的开课提醒</p>
                </WKOwnDialog>
            </div>
        )
    }
}

SubscribeChannel.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    account: state.account,
    channel: state.subscribeChannel.channel,
    showSubscribeChannel: state.subscribeChannel.showSubscribeChannel,
    liveroomId: state.channel.liveroom.id,
    channelId: state.channel.channel.id,
}))(SubscribeChannel)


// WEBPACK FOOTER //
// ./src/components/SubscribeChannel.js